import {
  defaultDirection,
  defaultLocale,
  defaultColor,
  localeOptions,
  themeColorStorageKey,
  themeRadiusStorageKey
} from '../constants/defaultValues';

const subdomain = window.location.hostname;
const subdomainParts = subdomain.split('.');
const domainName = subdomainParts.slice(-2).join('.');
console.log('domainName', domainName);

export const getRandomId = () => {
  const randomId = String(new Date().getTime()) + parseInt(Math.random() * 1000);
  return Number(randomId);
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;

  try {
    if (localStorage.getItem('direction')) {
      const localValue = localStorage.getItem('direction');
      if (localValue === 'rtl' || localValue === 'ltr') {
        direction = localValue;
      }
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getDirection -> error', error);
    direction = defaultDirection;
  }
  return {
    direction,
    isRtl: direction === 'rtl'
  };
};
export const setDirection = localValue => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  try {
    localStorage.setItem('direction', direction);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setDirection -> error', error);
  }
};

export const getCurrentColor = () => {
  let currentColor = defaultColor;
  try {
    if (localStorage.getItem(themeColorStorageKey)) {
      currentColor = localStorage.getItem(themeColorStorageKey);
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentColor -> error', error);
    currentColor = defaultColor;
  }
  return currentColor;
};

export const setCurrentColor = color => {
  try {
    localStorage.setItem(themeColorStorageKey, color);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentColor -> error', error);
  }
};

export const getCurrentRadius = () => {
  let currentRadius = 'rounded';
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      currentRadius = localStorage.getItem(themeRadiusStorageKey);
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentRadius -> error', error);
    currentRadius = 'rounded';
  }
  return currentRadius;
};
export const setCurrentRadius = radius => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentRadius -> error', error);
  }
};

export const getCurrentLanguage = () => {
  let language = defaultLocale;
  try {
    language =
      localStorage.getItem('currentLanguage') &&
      localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0
        ? localStorage.getItem('currentLanguage')
        : defaultLocale;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : getCurrentLanguage -> error', error);
    language = defaultLocale;
  }
  return language;
};
export const setCurrentLanguage = locale => {
  try {
    localStorage.setItem('currentLanguage', locale);
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentLanguage -> error', error);
  }
};

export const getCurrentUser = () => {
  let user = null;
  try {
    user = getJsonCookie('styli_sso_user', domainName) || null;
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js  : getCurrentUser -> error', error);
    user = null;
  }
  // console.log('cookie::',user);
  return user;
};

// export const getFirebaseUser = async() => {
//     return new Promise((resolve, reject) => {
//         try {
//             auth
//                 .onAuthStateChanged(user => {
//                     console.log('userChecked:', user)
//                     resolve(user);
//                 });
//         } catch {
//             reject('api failed')
//         }
//     });
// }

export const setCurrentUser = user => {
  const cookieName = 'styli_sso_user';
  console.log('setCurrentUser', user);
  try {
    if (user) {
      setJsonCookie(cookieName, user, 0, domainName);
      // localStorage.setItem('styli_sso_user', JSON.stringify(user));
    } else {
      // localStorage.removeItem('styli_sso_user');
      document.cookie = `${cookieName}=; domain=${domainName}; path=/;`;
    }
  } catch (error) {
    console.log('>>>>: src/helpers/Utils.js : setCurrentUser -> error', error);
  }
};

export const removeFromCookie = () => {
  const cookieName = 'styli_sso_user';
  document.cookie = `${cookieName}=; domain=${domainName}; path=/;`;
};

export const retry = (fn, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            reject(error);
            return;
          }

          // Passing on "reject" is the important part
          window.location.reload();
          // retry(fn, retriesLeft - 1, interval).then(resolve, reject)
        }, interval);
      });
  });
};

export const getLocalURL = (envKey, isSecondary) => {
  const cCuntry = localStorage.getItem('LOCATION');
  let iURL = process.env[envKey];
  if (iURL?.includes('localhost')) return iURL;
  const [, path] = iURL.split('//');
  if (iURL && cCuntry && isSecondary === true) {
    if (cCuntry === 'GULF') {
      iURL = `//in-${path}`;
    }
    return iURL;
  }

  if (iURL && cCuntry && cCuntry !== 'GULF') {
    iURL = `//${cCuntry.toLocaleLowerCase()}-${path}`;
  }
  return iURL;
};

const getJsonCookie = (cookieName, domain) => {
  const cookieValue = getCookie(cookieName, domain);
  if (cookieValue) {
    try {
      // Parse the JSON value from the cookie
      return JSON.parse(decodeURIComponent(cookieValue));
    } catch (error) {
      // Handle parsing errors if necessary
      console.error('Error parsing JSON from cookie:', error);
    }
  }

  return null; // Return null if the cookie or JSON value doesn't exist
};
const getCookie = (cookieName, domain) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    // Check if the cookie starts with the specified name
    if (cookie.indexOf(cookieName + '=') === 0) {
      // Check if the cookie domain matches the specified domain
      if (domain && cookie.indexOf('domain=' + domain) === -1) {
        return cookie.substring(cookieName.length + 1);
      }
    }
  }
  return null;
};

const setJsonCookie = (cookieName, jsonObject, expirationDays, domain) => {
  const jsonString = JSON.stringify(jsonObject);

  let cookieString = `${cookieName}=${encodeURIComponent(jsonString)}; path=/;`;

  if (expirationDays) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + expirationDays);
    cookieString += `; expires=${expirationDate.toUTCString()}`;
  }

  if (domain) {
    cookieString += `; domain=${domain}`;
  }

  document.cookie = cookieString;
};
